import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ error }) => (
  <div>{error}</div>
);

Error.propTypes = {
  error: PropTypes.string,
};

Error.defaultProps = {
  error: '',
};

export default Error;
